// Configuración y Globales
const MAX_RADIUS = window.PdvFungiConfig.maxRadius;
const CACHE_KEY = 'fungi_pdv_geo_cache';
const CACHE_TTL = 5 * 60 * 1000; // 5 minutos en milisegundos

let lastFocusedElement = null;
let scrollTimeout;
let geoTimeout;

// --- 📊 MEJORA 1: ANALYTICS AVANZADO (GA4) ---
function pdvTrack(eventName, params = {}) {
  if (window.gtag) {
    gtag('event', eventName, {
      ...params,
      section_name: 'Buscador Puntos de Venta'
    });
  }
}

function abrirMapa(nombre, direccion) {
  lastFocusedElement = document.activeElement; 
  const q = encodeURIComponent(direccion);
  
  // Tracking: Clic en ver mapa (Conversión de intención)
  pdvTrack('pdv_view_map', { store_name: nombre, store_address: direccion });

  document.getElementById('drawer-title').innerText = nombre;
  document.getElementById('drawer-address').innerText = direccion;
  document.getElementById('map-iframe').src = `https://maps.google.com/maps?q=${q}&t=&z=16&ie=UTF8&iwloc=&output=embed`;
  
  document.getElementById('pdv-drawer').classList.add('active');
  document.getElementById('pdv-overlay').classList.add('active');
  document.body.style.overflow = 'hidden';
  
  setTimeout(() => {
    const closeBtn = document.getElementById('pdv-btn-close');
    if(closeBtn) closeBtn.focus();
  }, 100);
}

function cerrarMapa() {
  document.getElementById('pdv-drawer').classList.remove('active');
  document.getElementById('pdv-overlay').classList.remove('active');
  document.getElementById('map-iframe').src = "";
  document.body.style.overflow = '';
  
  if (lastFocusedElement && typeof lastFocusedElement.focus === 'function') {
    lastFocusedElement.focus();
  }
  lastFocusedElement = null;
}

function calcularDistanciaKm(lat1, lon1, lat2, lon2) {
  const R = 6371;
  const dLat = (lat2 - lat1) * Math.PI / 180;
  const dLon = (lon2 - lon1) * Math.PI / 180;
  const a = Math.sin(dLat/2) * Math.sin(dLat/2) + Math.cos(lat1 * Math.PI / 180) * Math.cos(lat2 * Math.PI / 180) * Math.sin(dLon/2) * Math.sin(dLon/2);
  return R * (2 * Math.atan2(Math.sqrt(a), Math.sqrt(1-a)));
}

// --- 🔄 MEJORA 2: CACHÉ INTELIGENTE (LocalStorage) ---
function setGeoCache(lat, lng) {
  const data = {
    lat: lat,
    lng: lng,
    timestamp: Date.now()
  };
  localStorage.setItem(CACHE_KEY, JSON.stringify(data));
}

function getGeoCache() {
  const cached = localStorage.getItem(CACHE_KEY);
  if (!cached) return null;
  const data = JSON.parse(cached);
  if (Date.now() - data.timestamp > CACHE_TTL) {
    localStorage.removeItem(CACHE_KEY);
    return null;
  }
  return data;
}

function iniciarLocalizador() {
  if (window.pdvScrollHandler) {
    window.removeEventListener('scroll', window.pdvScrollHandler);
  }

  const cards = document.querySelectorAll('.pdv-card');
  const regionSelect = document.getElementById('filter-region');
  const comunaSelect = document.getElementById('filter-comuna');
  const initialMessage = document.getElementById('pdv-initial-message');
  const countContainer = document.getElementById('pdv-results-count');
  const countNum = document.getElementById('pdv-count-num');
  const countText = document.getElementById('pdv-count-text');
  const btnGeo = document.getElementById('btn-geolocate');
  const geoStatus = document.getElementById('geo-status');
  const geoStatusText = document.getElementById('geo-status-text');
  const loader = document.getElementById('pdv-loader');

  if (!regionSelect || !comunaSelect || !initialMessage) return;

  function normalizar(t) { return t ? t.normalize("NFD").replace(/[\u0300-\u036f]/g, "").toLowerCase().trim() : ""; }

  const storeData = Array.from(cards).map(card => ({
    el: card,
    regionRaw: card.dataset.region,
    regionKey: normalizar(card.dataset.region),
    comunaRaw: card.dataset.comuna,
    comunaKey: normalizar(card.dataset.comuna)
  }));

  const regionesMap = new Map();
  storeData.forEach(s => { if(s.regionKey) regionesMap.set(s.regionKey, s.regionRaw); });

  if (regionSelect.options.length <= 2) {
    Array.from(regionesMap.keys()).sort().forEach(key => {
      regionSelect.add(new Option(regionesMap.get(key), key));
    });
  }

  function poblarComunas(regionKey) {
    const comunasMap = new Map();
    storeData.forEach(s => { 
      if(s.regionKey === regionKey) comunasMap.set(s.comunaKey, s.comunaRaw); 
    });
    return Array.from(comunasMap.keys()).sort().map(key => new Option(comunasMap.get(key), key));
  }

  let itemsToShow = 12; 

  function mostrarTiendasProgresivo() {
    const pendingCards = Array.from(document.querySelectorAll('.pdv-card:not(.pdv-hidden)[data-status="pending"]'));
    if (pendingCards.length === 0) {
      if (loader) loader.style.display = 'none';
      return;
    }
    
    const nextBatch = pendingCards.slice(0, itemsToShow);
    nextBatch.forEach(card => {
      card.style.display = 'flex';
      card.classList.add('fade-in');
      card.removeAttribute('data-status');
    });

    if (loader) {
      loader.style.display = pendingCards.length > itemsToShow ? 'block' : 'none';
    }
  }

  window.pdvScrollHandler = () => {
    clearTimeout(scrollTimeout);
    scrollTimeout = setTimeout(() => {
      if ((window.innerHeight + window.scrollY) >= document.body.offsetHeight - 800) {
        mostrarTiendasProgresivo();
      }
    }, 100);
  };
  window.addEventListener('scroll', window.pdvScrollHandler);

  function showGeoStatus(text, isError = false, autoHide = false) {
    clearTimeout(geoTimeout);
    geoStatus.style.display = 'flex';
    geoStatus.className = isError ? "pdv-geo-status-box error" : "pdv-geo-status-box";
    geoStatusText.innerText = text;
    
    if (autoHide) {
      geoTimeout = setTimeout(() => { geoStatus.style.display = 'none'; }, 4000);
    }
  }

  // --- Función centralizada para procesar búsqueda GPS ---
  function procesarBusquedaGPS(lat, lng, source = 'gps_live') {
    let tiendasCercanas = [];
    storeData.forEach(s => {
      const tLat = parseFloat(s.el.getAttribute('data-lat'));
      const tLng = parseFloat(s.el.getAttribute('data-lng'));
      if(!isNaN(tLat) && !isNaN(tLng)) {
        const dist = calcularDistanciaKm(lat, lng, tLat, tLng);
        if (dist <= MAX_RADIUS) {
          tiendasCercanas.push({ el: s.el, dist: dist });
        }
      }
    });

    tiendasCercanas.sort((a, b) => a.dist - b.dist);
    regionSelect.value = 'all'; comunaSelect.value = 'all'; comunaSelect.disabled = false;
    
    storeData.forEach(s => {
      s.el.classList.add('pdv-hidden');
      s.el.style.display = 'none';
      s.el.removeAttribute('data-status');
    });
    
    if (tiendasCercanas.length > 0) {
      const grid = document.getElementById('pdv-grid');
      tiendasCercanas.forEach(item => {
        item.el.classList.remove('pdv-hidden');
        item.el.setAttribute('data-status', 'pending');
        const badge = item.el.querySelector('.pdv-distance-badge');
        if(badge) { 
          badge.style.display = 'block'; 
          badge.querySelector('.km-value').innerText = item.dist.toFixed(1); 
        }
        grid.appendChild(item.el);
      });

      initialMessage.classList.add('pdv-hidden');
      countContainer.classList.add('active');
      countNum.innerText = tiendasCercanas.length;
      countText.innerText = tiendasCercanas.length === 1 ? `tienda cercana` : `tiendas cercanas`;
      showGeoStatus(source === 'cache' ? '✅ Ubicación recuperada (instantánea)' : '✅ ¡Tiendas encontradas!', false, true);
      mostrarTiendasProgresivo(); 
    } else {
      showGeoStatus(`ℹ️ No encontramos tiendas a menos de ${MAX_RADIUS}km.`, true, true);
      initialMessage.classList.remove('pdv-hidden');
      countContainer.classList.remove('active');
    }

    // Tracking: Búsqueda GPS realizada
    pdvTrack('pdv_search', { 
      method: source, 
      results_count: tiendasCercanas.length,
      radius: MAX_RADIUS 
    });
  }

  if(btnGeo && !btnGeo.dataset.listener) {
    btnGeo.dataset.listener = "true"; 
    btnGeo.addEventListener('click', () => {
      btnGeo.disabled = true;

      // Intentar usar caché primero
      const cached = getGeoCache();
      if (cached) {
        procesarBusquedaGPS(cached.lat, cached.lng, 'cache');
        btnGeo.disabled = false;
        return;
      }

      showGeoStatus('🗺️ Obteniendo tu ubicación...', false, false);

      navigator.geolocation.getCurrentPosition((position) => {
        const uLat = position.coords.latitude;
        const uLng = position.coords.longitude;
        
        setGeoCache(uLat, uLng); // Guardar para la próxima vez
        procesarBusquedaGPS(uLat, uLng, 'gps_live');
        btnGeo.disabled = false;
      }, (error) => {
        btnGeo.disabled = false;
        let msg = '❌ Error de geolocalización.';
        if(error.code === 1) msg = '❌ Permiso denegado. Habilita el GPS.';
        showGeoStatus(msg, true, false);
        pdvTrack('pdv_search_error', { error_type: 'gps_denied' });
      });
    });
  }

  function filtrar(saveToCache = true) {
    const rSel = regionSelect.value;
    const cSel = comunaSelect.value;
    let visibles = 0;

    storeData.forEach(s => {
      if(s.el.querySelector('.pdv-distance-badge')) s.el.querySelector('.pdv-distance-badge').style.display = 'none';
      if((rSel === 'all' || rSel === s.regionKey) && rSel !== 'none' && (cSel === 'all' || cSel === s.comunaKey)) {
        s.el.classList.remove('pdv-hidden'); 
        s.el.style.display = 'none'; 
        s.el.setAttribute('data-status', 'pending');
        visibles++;
      } else { 
        s.el.classList.add('pdv-hidden'); 
        s.el.style.display = 'none';
        s.el.removeAttribute('data-status');
      }
    });

    initialMessage.classList.toggle('pdv-hidden', visibles > 0 || rSel !== 'none');
    countContainer.classList.toggle('active', rSel !== 'none');
    countNum.innerText = visibles;
    countText.innerText = visibles === 1 ? 'tienda' : 'tiendas';

    mostrarTiendasProgresivo(); 

    // Tracking: Búsqueda manual
    if(saveToCache && rSel !== 'none') {
      pdvTrack('pdv_search', { 
        method: 'manual', 
        region: rSel, 
        comuna: cSel, 
        results_count: visibles 
      });
    }

    const url = new URL(window.location);
    if(rSel !== 'none') url.searchParams.set('region', rSel); else url.searchParams.delete('region');
    if(cSel !== 'all') url.searchParams.set('comuna', cSel); else url.searchParams.delete('comuna');
    window.history.replaceState({}, '', url);

    if(saveToCache) {
      sessionStorage.setItem('pdv_region', rSel);
      sessionStorage.setItem('pdv_comuna', cSel);
    }
  }

  if (!regionSelect.dataset.listener) {
    regionSelect.dataset.listener = "true";
    regionSelect.addEventListener('change', function() {
      comunaSelect.innerHTML = '<option value="all">Todas las Comunas</option>';
      const val = this.value;
      comunaSelect.disabled = (val === 'all' || val === 'none');
      if(!comunaSelect.disabled) {
        poblarComunas(val).forEach(opt => comunaSelect.add(opt));
      }
      filtrar();
    });
  }

  if (!comunaSelect.dataset.listener) {
    comunaSelect.dataset.listener = "true";
    comunaSelect.addEventListener('change', filtrar);
  }

  // Restaurar filtros
  const params = new URLSearchParams(window.location.search);
  const regionToLoad = params.get('region') || sessionStorage.getItem('pdv_region');
  
  if (regionToLoad && regionToLoad !== 'none' && (regionesMap.has(regionToLoad) || regionToLoad === 'all')) {
    regionSelect.value = regionToLoad;
    if (regionToLoad !== 'all' && regionToLoad !== 'none') {
      comunaSelect.innerHTML = '<option value="all">Todas las Comunas</option>';
      poblarComunas(regionToLoad).forEach(opt => comunaSelect.add(opt));
      comunaSelect.disabled = false;
    }
    const comunaToLoad = params.get('comuna') || sessionStorage.getItem('pdv_comuna');
    if (comunaToLoad && Array.from(comunaSelect.options).some(opt => opt.value === comunaToLoad)) {
      comunaSelect.value = comunaToLoad;
      filtrar(false);
    } else {
      filtrar(false); 
    }
  }
}

// --- Listeners Globales ---
if (!window.pdvGlobalListeners) {
  window.pdvGlobalListeners = true;
  document.addEventListener('click', (e) => {
    // Ver en Mapa
    const btn = e.target.closest('[data-action="open-map"]');
    if (btn) {
      abrirMapa(btn.dataset.name, btn.dataset.address);
      return;
    }
    // Cerrar Mapa
    if (e.target.closest('#pdv-btn-close') || e.target.id === 'pdv-overlay') {
      cerrarMapa();
      return;
    }
    // Cerrar Notificación Geo
    if (e.target.closest('.pdv-geo-close')) {
      const box = e.target.closest('.pdv-geo-status-box');
      if (box) box.style.display = 'none';
      return;
    }
    // Tracking: Clic en Instagram / Web (Conversión externa)
    const extraLink = e.target.closest('.pdv-link-extra');
    if (extraLink) {
      pdvTrack('pdv_external_click', { url: extraLink.href });
    }
  });

  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape' && document.getElementById('pdv-drawer').classList.contains('active')) {
      cerrarMapa();
    }
  });
}

// Carga asíncrona de páginas adicionales (Paginación silenciosa)
async function cargarTiendasRestantes() {
  const tracker = document.getElementById('pdv-pag-track');
  if (!tracker) return;
  let nextUrl = tracker.dataset.next;
  if (nextUrl && !nextUrl.startsWith('http')) nextUrl = window.location.origin + nextUrl;
  const grid = document.getElementById('pdv-grid');
  while (nextUrl) {
    try {
      const res = await fetch(nextUrl);
      const html = await res.text();
      const parser = new DOMParser();
      const doc = parser.parseFromString(html, 'text/html');
      const nuevasCards = doc.querySelectorAll('.pdv-card');
      nuevasCards.forEach(card => grid.appendChild(card));
      const newTracker = doc.querySelector('#pdv-pag-track');
      nextUrl = newTracker?.dataset.next || null;
      if (nextUrl && !nextUrl.startsWith('http')) nextUrl = window.location.origin + nextUrl;
    } catch (e) { break; }
  }
  tracker.remove();
  iniciarLocalizador();
}

document.addEventListener("DOMContentLoaded", async () => {
  if (document.getElementById('pdv-pag-track')?.dataset.next) {
    await cargarTiendasRestantes();
  } else {
    iniciarLocalizador();
  }
});

document.addEventListener("shopify:section:load", iniciarLocalizador);